<div class="flex ion-justify-content-between fs-14 font-medium">
  <div>
    <div class="label">{{ 'pages.approvals.details.totalBudget' | translate }}</div>
    <div class="value" data-cy="Item budget total amount">{{ subtask.totalBudget | fixBackendPrice | currency: 'EUR' }}</div>
  </div>
  <div>
    <div class="label">{{ 'pages.approvals.details.approvedBudget' | translate }}</div>
    <div class="value" data-cy="Item budget used amount">{{ subtask.usedBudget | fixBackendPrice | currency: 'EUR' }}</div>
  </div>
  <div>
    <div class="label">{{ 'pages.approvals.details.residualBudget' | translate }}</div>
    <div class="value" data-cy="Item budget residual amount">{{ subtask.residualBudget | fixBackendPrice | currency: 'EUR' }}</div>
  </div>
</div>
